export default{
    //后端基础路径
    // BASE_URL: "http://112.86.129.73:3000/battle",
    BASE_URL: "http://localhost:8080/api",
    //更新服务器路径
    UPDATE_URL: "http://43.154.207.136:8080/api/"
}